<script>
  //@ts-check
  import Icon from "../../atoms/Icon.svelte";
  import Rule from "../../atoms/Rule.svelte";
  import { validatePropObjectWithSchema } from "../../utilities/logs";
  import { getTheme } from "../../utilities/themes";
  // @ts-ignore
  // eslint-disable-next-line no-unused-vars
  import * as Types from "./globalNavigationTypes";

  /** @type {Types.Link} */
  export let link;

  /** @type {import('../../utilities/themes.js').ThemeName} */
  export let theme = "lightGrey";

  const linkSchema = {
    url: "string",
    label: "string"
  };

  validatePropObjectWithSchema({
    componentName: "StaticMenuLink",
    propName: "link",
    propValue: link,
    schema: linkSchema
  });

  $: colorTheme = getTheme(theme);
</script>

<a
  id={link.id}
  data-sveltekit-reload
  href={link.url}
  target={link.url && link.isExternal ? "_blank" : null}
  rel={link.url && link.isExternal ? "noopener noreferrer" : null}
  class="group my-4 flex items-center justify-between transition group-last-of-type/li:mb-0 {colorTheme.textColor} {colorTheme.hoverTextColor} focus-visible:outline-dashed focus-visible:outline-offset-4 {colorTheme.focusOutlineColor} {colorTheme.focusTextColor}"
>
  <span class="heading-xs block lg:cta-lg xl:heading-xs">{link.label}</span>
  <div
    class="ml-1 grid
            h-[14px]
            w-[14px]
            place-items-center transition-opacity
            group-hover:opacity-opaque
            group-focus:opacity-opaque lg:h-[22px]
            lg:w-[22px] lg:text-cobalt-blue lg:opacity-transparent
          "
  >
    <Icon name="arrowRight" inheritSize />
  </div>
</a>
<div class="group-last-of-type/li:hidden">
  <Rule type="thin" {theme} />
</div>
